<template>
  <vuestic-modal :show.sync="modal.show" ref="smallModal" v-bind:small="false" :cancelClass="'none'" okText="Fechar"
    cancelText="Fechar">
    <div slot="title">Informações</div>

    <div v-show="modal.load">
      <div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
        <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
          <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80">
          </component>
        </div>
      </div>
    </div>
    <div v-show="!modal.load">
      <vuestic-tabs :names="['Dados Básicos']" ref="tabs">
        <div slot="Dados Básicos">
          <div class="row">
            <div class="col-md-2">
              <strong class="font-weight-bold">Ativo?</strong><br>
              <span class="circle badge-success" v-if="modal.conteudo.flg_ativo"></span>
              <span class="circle badge-danger" v-if="!modal.conteudo.flg_ativo"></span>
            </div>
            <div class="col-md-4">
              <strong class="font-weight-bold">Renavam:</strong><br>
              {{ modal.conteudo.renavam }}
            </div>
            <div class="col-md-6">
              <strong class="font-weight-bold">Chassi:</strong><br>
              {{ modal.conteudo.chassi }}
            </div>
          </div>
        </div>
      </vuestic-tabs>
    </div>
  </vuestic-modal>
</template>

<script>
import * as spinners from 'epic-spinners'
import VeiculosController from './VeiculosController'

export default {
  name: 'InfoModal',
  components: {
    ...spinners,
  },
  data() {
    return {
      modal: {
        show: false,
        load: false,
        conteudo: {}
      },
    }
  },
  async mounted() {

  },
  methods: {
    async open(id) {
      this.detalhes(id)
    },
    detalhes(id) {
      let self = this

      this.$refs.smallModal.open()
      this.modal.load = true
      this.modal.conteudo = {}

      VeiculosController.getVeiculoById(id, function (response) {
        self.modal.conteudo = response.body.dados
        self.modal.load = false
      })
    },
  }
}
</script>

<style lang="scss" scoped></style>